const checkIsSuccessAction = (code) => code === 0

export default checkIsSuccessAction